import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    maxWidth: 400,
    minWidth: 300,
    maxHeight: 400,
    p: 3,
    borderRadius: 1,
    boxShadow: 24,
    overflowX: "auto",
};

export default function DeleteConfirmModal(props) {

    return (
        <>
            <Modal
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby='confirm-delete-modal'
                aria-describedby='confirm-deletion'
            >
                <Box sx={style} justifyItems='center'>
                    <Typography
                        textAlign='center'
                    >
                        Are you sure you want to delete {props.type}:
                    </Typography>
                    <Typography
                        textAlign='center'
                        sx={{marginBottom: 3, wordBreak: "break-all", fontSize: "20px"}}
                    >
                        {props.content}
                    </Typography>
                    <Stack direction='row' justifyContent="center" spacing={3}>
                        <Button onClick={props.handleClose} variant='outlined' fullWidth>
                            Cancel
                        </Button>
                        <Button onClick={e => {props.handleDelete(); props.handleClose(e)}} color="error" variant='contained' fullWidth>
                            Delete
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </>
    );
}
